import React from 'react';
// components
import { Box } from '@mui/material';

import ToggleButton from '@mui/lab/ToggleButton';
import { makeStyles } from '@mui/styles';
import { InputLabelBase } from '../../inputs/InputLabelBase';
import { RegisteredToggleButtonGroup } from '../../Buttons/registered/v7/RegistedToggleButtonGroup';

const LabelProps = {
  required: true,
  TypographyProps: {
    variant: 'body2',
    gutterBottom: true,
  },
};

export const P100SecurityQuestionsFields = ({ disabled }: any) => {
  const classes = useStyles();

  const toggleButtonProps = React.useMemo(
    () => ({
      disabled,
      className: classes.toggleButton,
      classes: {
        disabled: classes.toggleButtonDisabled,
      },
    }),
    // eslint-disable-next-line
    [disabled]
  );

  return (
    <div style={{ paddingLeft: '25px', paddingRight: '25px' }}>
        <Box>
          <InputLabelBase {...LabelProps} style={{ paddingTop: 0 }}>
            Have you ever had any cyber insurance claim(s)?
          </InputLabelBase>
          <RegisteredToggleButtonGroup name="claimHistory" exclusive>
            <ToggleButton value={0} {...toggleButtonProps}>
              <Box>Never</Box>
            </ToggleButton>
            <ToggleButton value={1} {...toggleButtonProps}>
              <Box>Within last 12 months</Box>
            </ToggleButton>
            <ToggleButton value={2} {...toggleButtonProps}>
              <Box>Within last 2 years</Box>
            </ToggleButton>
            <ToggleButton value={3} {...toggleButtonProps}>
              <Box>Within last 3 years</Box>
            </ToggleButton>
            <ToggleButton value={4} {...toggleButtonProps}>
              <Box>Within last 4 years</Box>
            </ToggleButton>
            <ToggleButton value={5} {...toggleButtonProps}>
              <Box>within 5 years or more</Box>
            </ToggleButton>
          </RegisteredToggleButtonGroup>
        </Box>
        <Box>
          <InputLabelBase {...LabelProps}>
            Does your organization have a Designated Information Security
            Contact?
          </InputLabelBase>
          <RegisteredToggleButtonGroup name="isSecurityOfficer" exclusive>
            <ToggleButton value {...toggleButtonProps}>
              <Box>Yes</Box>
            </ToggleButton>
            <ToggleButton value={false} {...toggleButtonProps}>
              <Box>No</Box>
            </ToggleButton>
          </RegisteredToggleButtonGroup>
        </Box>
        <Box>
          <InputLabelBase {...LabelProps}>
            Does your organization provide mandatory information security
            training to all employees at least annually? If not, are you willing
            to implement it during the policy period?
          </InputLabelBase>
          <RegisteredToggleButtonGroup name="isSecurityTraining" exclusive>
            <ToggleButton value {...toggleButtonProps}>
              <Box>Yes</Box>
            </ToggleButton>
            <ToggleButton value={false} {...toggleButtonProps}>
              <Box>No</Box>
            </ToggleButton>
          </RegisteredToggleButtonGroup>
        </Box>
        <Box>
          <InputLabelBase {...LabelProps}>
            Does your organization encrypt emails, mobile and computing devices
            containing sensitive information (e.g., PII, PHI, PCI) sent to
            external parties?
          </InputLabelBase>
          <RegisteredToggleButtonGroup name="useEncryption" exclusive>
            <ToggleButton value {...toggleButtonProps}>
              <Box>Yes</Box>
            </ToggleButton>
            <ToggleButton value={false} {...toggleButtonProps}>
              <Box>No</Box>
            </ToggleButton>
          </RegisteredToggleButtonGroup>
        </Box>
        <Box>
          <InputLabelBase {...LabelProps}>
            Does your organization have sensitive information stored on the
            cloud?
          </InputLabelBase>
          <RegisteredToggleButtonGroup name="useCloudStorage" exclusive>
            <ToggleButton value {...toggleButtonProps}>
              <Box>Yes</Box>
            </ToggleButton>
            <ToggleButton value={false} {...toggleButtonProps}>
              <Box>No</Box>
            </ToggleButton>
          </RegisteredToggleButtonGroup>
        </Box>
      </div>
  );
};

const useStyles = makeStyles(({ palette }) => {
  return {
    toggleButton: {
      padding: '0.5rem 4rem',
      marginBottom: '0.75rem',
    },
    toggleButtonDisabled: {
      color: `${palette.primary.contrastText} !important`,
    },
  };
});
